// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Footnotes_TheComp__XV7Gc"};